import { render, staticRenderFns } from "./numero_magazziniere.vue?vue&type=template&id=0896343b&"
import script from "./numero_magazziniere.vue?vue&type=script&lang=js&"
export * from "./numero_magazziniere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports